export const SET_HOUSE_DETAIL_INFO = 'SET_HOUSE_DETAIL_INFO';
export const SET_COUNTRY_CONFIG = 'SET_COUNTRY_CONFIG';

export const FETCH_HOUSE_DETAIL_INFO = 'FETCH_HOUSE_DETAIL_INFO';
export const FETCH_COUNTRY_CONFIG = 'FETCH_COUNTRY_CONFIG';

